import React from 'react';
import i18n from '../../i18n/i18n.js';
import { Link } from "react-router-dom";
import Form from '../../components/Forms/Form/Form';
import { NavigateTo, Utils } from '../../Utils.js';
import { withAppContext } from '../../contexts/AppContext';
import './Contact.css'; 
import { th } from 'framer-motion/client';
import PageHeader from '../../components/PageHeader/PageHeader.js';

class Contact extends React.Component {
    
    state = {
      redirect: false,
      submitSuccess: false,
    };

    constructor(props) {
      super(props);
      
      this.appRef = this.props.appContext.appRef;
      this.formRef = React.createRef();
    }

    hiddens = {
    };

  /**
   * Form hívja meg ha változás történt egy mezőben
   */
  on_form_change(key, value) {
    
  }

  /**
   * Form hívja meg ha sikeresen lefutott a handle_submit()
   * ha nincs szükség erre a fv.-re akkor lehet törölni
   */
  on_submit_success(params = {formData: {}, result: {}}) {
    this.setState({ submitSuccess: true });
  }

  render() { 

    return <div className={`container floating_container page_account_create`}>
      <div className='floating_container_header no_drop_shadow no_border'>
        <PageHeader isHistoryBack={true} no_close={true} title={i18n.t('contactTitle')}></PageHeader>
      </div>
      <div className="floating_container_content">
       
        {this.state.submitSuccess ? (
          <div className="form_wrapper">
            <div className="successfull_message">
              {i18n.t('contactSuccessMessage')}
            </div>
          </div>
        ) : (
          <div className="form_wrapper"> 
            <Form onSuccess={(params) => {this.on_submit_success(params)}} ref={this.formRef} hiddens={this.hiddens} name="app_contact" submit_text={i18n.t('contactSubmit')} parent={this} />
          </div>
        )}
      </div>
    </div>;
  }

}

export default withAppContext(Contact);